import { PaymentOptionStorageDto } from './PaymentOptionStorageDto';
import { PaymentPlanDto } from './PaymentPlanDto';
import { PaymentPlanPromotionDto } from './PaymentPlanPromotionDto';

export class PaymentPlanStorageDto {
    readonly weeklyPrice: string;

    readonly discountApplied: string;

    readonly contractLengthRatio: string;

    readonly paymentPlanPremiumRatio: string;

    readonly paymentOptions: PaymentOptionStorageDto[];

    readonly promotion: PaymentPlanPromotionDto | null;

    readonly totalRent: string;

    readonly subtotal: string;

    readonly genericPrice: string;

    constructor(paymentPlan: PaymentPlanDto) {
        this.weeklyPrice = paymentPlan.weeklyPrice.toFixed(2);
        this.discountApplied = paymentPlan.discountApplied.toFixed(2);
        this.contractLengthRatio = paymentPlan.contractLengthRatio.toFixed(2);
        this.paymentPlanPremiumRatio = paymentPlan.paymentPlanPremiumRatio.toFixed(2);
        this.paymentOptions = paymentPlan.paymentOptions.map(
            (option) => new PaymentOptionStorageDto(option)
        );
        this.promotion = paymentPlan.promotion
            ? new PaymentPlanPromotionDto(paymentPlan.promotion)
            : null;
        this.totalRent = paymentPlan.totalRent.toFixed(2);
        this.subtotal = paymentPlan.subtotal.toFixed(2);
        this.genericPrice = paymentPlan.genericPrice.toFixed(2);
    }
}
